import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "open"],
    _excluded2 = ["children", "open"],
    _excluded3 = ["children", "onClick", "icon", "wrapperStyle", "IconComponent"],
    _excluded4 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";

/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useSpring, animated } from '@react-spring/web';
import { IconButton } from '../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AccordionContext = /*#__PURE__*/React.createContext({
  isOpen: false,
  setIsOpen: function setIsOpen() {}
});
export var useAccordionContext = function useAccordionContext() {
  return React.useContext(AccordionContext);
};
export var AccordionV2 = function AccordionV2(_ref) {
  var children = _ref.children,
      open = _ref.open,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  React.useEffect(function () {
    if (typeof open !== 'undefined') setIsOpen(open);
  }, [open]);
  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: {
      isOpen: isOpen,
      setIsOpen: setIsOpen
    },
    children: /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }))
  });
};
export default AccordionV2;

var Wrapper = function Wrapper(_ref2) {
  var children = _ref2.children,
      open = _ref2.open,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Disclosure, _objectSpread(_objectSpread({
    as: "div"
  }, rest), {}, {
    children: children
  }));
};

var AccordionButton = function AccordionButton(_ref3) {
  var children = _ref3.children,
      _onClick = _ref3.onClick,
      icon = _ref3.icon,
      wrapperStyle = _ref3.wrapperStyle,
      IconComponent = _ref3.IconComponent,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  var _useAccordionContext = useAccordionContext(),
      isOpen = _useAccordionContext.isOpen,
      setIsOpen = _useAccordionContext.setIsOpen;

  if (IconComponent) {
    return /*#__PURE__*/_jsxs(ButtonContentWrapper, {
      twStyle: wrapperStyle,
      children: [children, /*#__PURE__*/_jsx(StyledIconContainer, {
        isOpen: isOpen,
        children: /*#__PURE__*/_jsx(IconButton, {
          ariaLabel: "",
          Icon: IconComponent,
          onClick: function onClick() {
            !!_onClick && _onClick();
            setIsOpen(!isOpen);
          }
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx(Disclosure.Button, _objectSpread(_objectSpread({
    onClick: function onClick() {
      !!_onClick && _onClick();
      setIsOpen(!isOpen);
    }
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(ButtonContentWrapper, {
      twStyle: wrapperStyle,
      children: [children, /*#__PURE__*/_jsx(StyledIconContainer, {
        isOpen: isOpen,
        children: icon ? icon : /*#__PURE__*/_jsx(_StyledChevronDownIcon, {})
      })]
    })
  }));
};

var AccordionPanel = function AccordionPanel(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  var _useAccordionContext2 = useAccordionContext(),
      isOpen = _useAccordionContext2.isOpen; // add accordion animation from top to down using react-spring


  var accordionAnimation = useSpring({
    height: isOpen ? 'auto' : 0,
    opacity: isOpen ? 1 : 0,
    marginTop: isOpen ? 0 : -3.5,
    config: {
      tension: 300,
      friction: 20
    }
  });
  return /*#__PURE__*/_jsx(animated.div, {
    style: _objectSpread({}, accordionAnimation),
    children: /*#__PURE__*/_jsx(Transition, {
      show: isOpen,
      children: /*#__PURE__*/_jsx(Disclosure.Panel, _objectSpread(_objectSpread({}, rest), {}, {
        children: children
      }))
    })
  });
};

var StyledIconContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "accordion-v2__StyledIconContainer",
  componentId: "sc-14wsqqq-0"
})(function (_ref5) {
  var isOpen = _ref5.isOpen;
  return [{
    "height": "fit-content",
    "width": "fit-content",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "transitionProperty": "transform",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms"
  }, isOpen && {
    "--tw-rotate": "180deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
  }];
});

var ButtonContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "accordion-v2__ButtonContentWrapper",
  componentId: "sc-14wsqqq-1"
})(["", ";", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
}, function (_ref6) {
  var twStyle = _ref6.twStyle;
  return Array.isArray(twStyle) ? twStyle : [];
});

AccordionV2.Button = AccordionButton;
AccordionV2.Panel = AccordionPanel;

var _StyledChevronDownIcon = /*#__PURE__*/_styled(ChevronDownIcon).withConfig({
  displayName: "accordion-v2___StyledChevronDownIcon",
  componentId: "sc-14wsqqq-2"
})({
  "height": "1rem",
  "width": "1rem"
});